import api from "../utils/api";
import { LOGOUT } from "./types";

export const byPerson = ({ personUuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/v1/roles/people/u/${personUuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get(`/v1/roles/people/f/mine`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const save = (payload) => async (dispatch) => {
    try {
        const res = await api.post(`/v1/roles/people`, payload);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/v1/roles/people/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};